const endpoints = {
  /* ── 서비스 API (유저용) ── */
  auth: {
    signup: '/api/auth/signup',
    login: '/api/auth/login',
    logout: '/api/auth/logout',
    me: '/api/auth/me',
    oAuth: (provider) => `/api/auth/oauth/${provider}`,
    passwordResetRequest: '/api/auth/password/reset-request',
    passwordReset: '/api/auth/password/reset',
    guestVerify: '/api/auth/guest/verify',
    guestConfirm: '/api/auth/guest/confirm',
  },
  users: {
    me: '/api/users/me',
    password: '/api/users/me/password',
    reviews: '/api/users/me/reviews',
    waitlist: '/api/users/me/waitlist',
  },
  reservations: {
    list: '/api/reservations',
    create: '/api/reservations',
    lookup: '/api/reservations/lookup',
    detail: (id) => `/api/reservations/${id}`,
    receiptUrl: (id) => `/api/reservations/${id}/receipt-url`,
    cancel: (id) => `/api/reservations/${id}/cancel`,
    rebook: (id) => `/api/reservations/${id}/rebook`,
  },
  payments: {
    prepare: '/api/payments/prepare',
    confirm: '/api/payments/confirm',
    cards: '/api/payments/cards',
    cardDelete: (id) => `/api/payments/cards/${id}`,
    detail: (id) => `/api/payments/${id}`,
    refund: (id) => `/api/payments/${id}/refund`,
    receipt: (id) => `/api/payments/${id}/receipt`,
    receiptEmail: (id) => `/api/payments/${id}/receipt/email`,
  },
  waitlist: {
    list: '/api/waitlist',
    create: '/api/waitlist',
    cancel: (id) => `/api/waitlist/${id}`,
    convert: (id) => `/api/waitlist/${id}/convert`,
  },
  price: {
    search: '/api/price/search',
    options: '/api/price/options',
    surcharges: '/api/price/surcharges',
    config: (serviceType) => `/api/price/config/${serviceType}`,
  },
  coupons: {
    validate: '/api/coupons/validate',
  },
  availability: {
    check: '/api/availability/check',
    calendar: '/api/availability/calendar',
  },
  common: {
    airports: '/api/airports',
    golfCourses: '/api/golf-courses',
    golfCourseDetail: (id) => `/api/golf-courses/${id}`,
    skiResorts: '/api/ski-resorts',
    hospitals: '/api/hospitals',
    hospitalDetail: (id) => `/api/hospitals/${id}`,
    hospitalRegions: '/api/hospital-regions',
    departureRegions: '/api/departure-regions',
    bufferSettings: '/api/buffer-settings',
    vehicles: '/api/vehicles',
    holidays: '/api/holidays',
    translations: '/api/translations',
  },
  main: {
    banners: '/api/main/banners',
  },
  tours: {
    list: '/api/tours',
    detail: (id) => `/api/tours/${id}`,
    schedules: (id) => `/api/tours/${id}/schedules`,
    createReservation: (tourId) => `/api/tours/${tourId}/reservations`,
  },
  shopping: {
    products: '/api/shopping/products',
    productDetail: (id) => `/api/shopping/products/${id}`,
    cart: '/api/shopping/cart',
    cartItem: (id) => `/api/shopping/cart/${id}`,
    orders: '/api/shopping/orders',
    orderDetail: (id) => `/api/shopping/orders/${id}`,
    refundRequest: (id) => `/api/shopping/orders/${id}/refund-request`,
  },
  reviews: {
    list: '/api/reviews',
    create: '/api/reviews',
    detail: (id) => `/api/reviews/${id}`,
    stats: '/api/reviews/stats',
  },
  faq: {
    list: '/api/faq',
    categories: '/api/faq/categories',
    detail: (id) => `/api/faq/${id}`,
  },
  inquiries: {
    list: '/api/inquiries',
    create: '/api/inquiries',
    detail: (id) => `/api/inquiries/${id}`,
  },
  notifications: {
    list: '/api/notifications',
    read: (id) => `/api/notifications/${id}/read`,
  },
  partners: {
    apply: '/api/partners/apply',
    me: '/api/partners/me',
  },
  upload: '/api/upload',
  uploadImage: '/api/upload/image',

  /* ── 관리자 API (Admin) ── */
  admin: {
    reservations: {
      list: '/api/admin/reservations',
      detail: (id) => `/api/admin/reservations/${id}`,
      status: (id) => `/api/admin/reservations/${id}/status`,
      memo: (id) => `/api/admin/reservations/${id}/memo`,
      driverInfo: (id) => `/api/admin/reservations/${id}/driver-info`,
      extraCharge: (id) => `/api/admin/reservations/${id}/extra-charge`,
      unblock: (id) => `/api/admin/reservations/${id}/unblock`,
      bufferAfter: (id) => `/api/admin/reservations/${id}/buffer-after`,
    },
    schedule: {
      calendar: '/api/admin/schedule',
      block: '/api/admin/schedule/block',
      blockDelete: (id) => `/api/admin/schedule/block/${id}`,
    },
    holidays: {
      list: '/api/admin/holidays',
      detail: (id) => `/api/admin/holidays/${id}`,
    },
    buffer: '/api/admin/buffer',
    waitlist: {
      list: '/api/admin/waitlist',
      notify: (id) => `/api/admin/waitlist/${id}/notify`,
    },
    price: {
      airport: '/api/admin/price/airport',
      airportRegion: (id) => `/api/admin/price/airport/${id}`,
      golf: '/api/admin/price/golf',
      golfDetail: (id) => `/api/admin/price/golf/${id}`,
      golfRegional: '/api/admin/price/golf-regional',
      golfRegionalDetail: (id) => `/api/admin/price/golf-regional/${id}`,
      options: '/api/admin/price/options',
      optionDetail: (id) => `/api/admin/price/options/${id}`,
      pet: '/api/admin/price/pet',
      business: '/api/admin/price/business',
      ski: '/api/admin/price/ski',
      skiDetail: (id) => `/api/admin/price/ski/${id}`,
      surcharges: '/api/admin/price/surcharges',
      onsiteSurcharges: '/api/admin/price/onsite-surcharges',
      hospitalRegional: '/api/admin/price/hospital-regional',
      hospitalRegionalDetail: (id) => `/api/admin/price/hospital-regional/${id}`,
    },
    golfCourses: {
      list: '/api/admin/golf-courses',
      detail: (id) => `/api/admin/golf-courses/${id}`,
    },
    // BugHerd #99: 스키장 CRUD admin endpoint (2026.03.10 제거 후 정책 변경으로 복원).
    skiResorts: {
      list: '/api/admin/ski-resorts',
      detail: (id) => `/api/admin/ski-resorts/${id}`,
    },
    hospitals: {
      list: '/api/admin/hospitals',
      detail: (id) => `/api/admin/hospitals/${id}`,
    },
    departureRegions: {
      list: '/api/admin/departure-regions',
      detail: (id) => `/api/admin/departure-regions/${id}`,
    },
    hospitalRegions: {
      list: '/api/admin/hospital-regions',
      detail: (id) => `/api/admin/hospital-regions/${id}`,
    },
    vehicles: {
      list: '/api/admin/vehicles',
      detail: (id) => `/api/admin/vehicles/${id}`,
    },
    tours: {
      list: '/api/admin/tours',
      detail: (id) => `/api/admin/tours/${id}`,
      schedules: (tourId) => `/api/admin/tours/${tourId}/schedules`,
      scheduleDetail: (tourId, schedId) => `/api/admin/tours/${tourId}/schedules/${schedId}`,
    },
    shopping: {
      products: '/api/admin/shopping/products',
      productDetail: (id) => `/api/admin/shopping/products/${id}`,
      orders: '/api/admin/shopping/orders',
      orderStatus: (id) => `/api/admin/shopping/orders/${id}/status`,
      orderDetail: (id) => `/api/admin/shopping/orders/${id}/detail`,
      orderRefund: (id) => `/api/admin/shopping/orders/${id}/refund`,
      refundRequests: '/api/admin/shopping/refund-requests',
      refundApprove: (id) => `/api/admin/shopping/refund-requests/${id}/approve`,
      refundReject: (id) => `/api/admin/shopping/refund-requests/${id}/reject`,
    },
    reviews: {
      list: '/api/admin/reviews',
      detail: (id) => `/api/admin/reviews/${id}`,
      status: (id) => `/api/admin/reviews/${id}/status`,
    },
    users: {
      list: '/api/admin/users',
      detail: (id) => `/api/admin/users/${id}`,
      status: (id) => `/api/admin/users/${id}/status`,
      reservations: (id) => `/api/admin/users/${id}/reservations`,
      reviews: (id) => `/api/admin/users/${id}/reviews`,
    },
    partners: {
      list: '/api/admin/partners',
      status: (id) => `/api/admin/partners/${id}/status`,
    },
    faq: {
      list: '/api/admin/faq',
      detail: (id) => `/api/admin/faq/${id}`,
    },
    inquiries: {
      list: '/api/admin/inquiries',
      detail: (id) => `/api/admin/inquiries/${id}`,
    },
    transactions: {
      list: '/api/admin/transactions',
      summary: '/api/admin/transactions/summary',
      export: '/api/admin/transactions/export',
      detail: (id) => `/api/admin/transactions/${id}`,
    },
    translations: {
      list: '/api/admin/translations',
      detail: (id) => `/api/admin/translations/${id}`,
      autoTranslate: '/api/admin/translations/auto-translate',
    },
    images: {
      list: '/api/admin/images',
      detail: (id) => `/api/admin/images/${id}`,
    },
    banners: {
      list: '/api/admin/banners',
      detail: (id) => `/api/admin/banners/${id}`,
    },
    notifications: {
      list: '/api/admin/notifications',
      send: '/api/admin/notifications/send',
    },
    coupons: {
      list: '/api/admin/coupons',
      detail: (id) => `/api/admin/coupons/${id}`,
      usages: (id) => `/api/admin/coupons/${id}/usages`,
    },
    settings: {
      list: '/api/admin/settings',
      detail: (key) => `/api/admin/settings/${key}`,
    },
    // AUDIT_G30: OTA 채널 (Klook/Viator/Trip.com) 등록·동기화 로그 관리
    ota: {
      channels: '/api/admin/ota/channels',
      channelDetail: (id) => `/api/admin/ota/channels/${id}`,
      syncLogs: '/api/admin/ota/sync-logs',
    },
  },
};

export default endpoints;
